import { some } from 'lodash';

import apiFetch from '../../api-fetch';
import { sendSlackNotification } from '..';
import { logApiCall } from '../../client-logs';
import fetchCacheStore from '../../with-fetch/src/cache/FetchCacheStore';

const forceResendWorkout = async (workoutItem) => {
  console.devLog.info('force send workout called...');

  if (workoutItem.id < 0) {
    sendSlackNotification({
      title: 'Client workout is trying to create via backup system',
      datetime: new Date().toDateString(),
      message: `Workout: ${JSON.stringify(workoutItem)},
      )}`,
      env: 'forceResendWorkout function duplicate creator blocker',
      platformName: 'CMA',
    });
    console.devLog.info(
      'Bailing on force resend workout to make sure we cannot create duplicates. We are relying on the queue.',
    );
    return;
  }
  const config = {
    url: 'Client/UpdateWorkoutLog',
    method: 'POST',
    query: {
      id: workoutItem.id,
      // debugVersion: workoutItem.version,
    },
    body: workoutItem,
  };

  let result;
  try {
    result = await apiFetch(config);

    sendSlackNotification({
      title: 'We forced a client version to the server, huzzah!',
      datetime: new Date().toDateString(),
      message: `Workout: ${JSON.stringify(workoutItem)},
      )}, result: ${JSON.stringify(result)}`,
      env: 'forceResendWorkout function',
      platformName: 'CMA',
    });
  } catch (e) {
    console.devLog.info(
      'Failed to send the newer item to the server due to: ',
      e,
    );

    sendSlackNotification({
      title: 'A client workout FAILED to be forced to the server',
      datetime: new Date().toDateString(),
      message: `Workout: ${JSON.stringify(workoutItem)},
        )}, result: ${JSON.stringify(result)}`,
      env: 'forceResendWorkout function CATCH',
      platformName: 'CMA',
    });

    logApiCall({
      description:
        'Logging a failure to force resend a newer client version to the server',
      url: 'Client/UpdateWorkoutLog',
      isComplete: workoutItem.isComplete,
      body: workoutItem,
      forceLog: true,
      timestamp: new Date().toISOString(),
      response: result,
    });
  }
};

const checkForMismatchedWorkouts = async () => {
  const config = {
    url: 'Client/MyWorkoutLogVersions',
    method: 'GET',
  };

  try {
    const results = await apiFetch(config);
    // console.devLog.info('Results:', results);
    // Check through the cache for workout logs and see if any of them have a later version
    if (results && results.length > 0) {
      // Should be an object of shape
      // {
      //  WorkoutLogId, Version
      // }
      const cacheResults = fetchCacheStore.getCached(
        'Client/MyWorkoutLogsData',
        undefined,
      );
      // console.devLog.info('Cache result in checked for mismatched...', cacheResults);
      if (!cacheResults || !cacheResults.data || cacheResults.data <= 0) {
        return null;
      }
      const workoutsToSend = cacheResults.data.filter((cachedWorkoutLog) =>
        some(
          results,
          (result) =>
            cachedWorkoutLog.id === result.workoutLogId &&
            cachedWorkoutLog.version > result.version,
        ),
      );

      // console.devLog.info('Workouts to send:', workoutsToSend);

      if (workoutsToSend && workoutsToSend.length > 0) {
        workoutsToSend.forEach(async (workoutToSend) => {
          await forceResendWorkout(workoutToSend);
        });
      }
    }
  } catch (e) {
    console.devLog.info('Error checking workout log versions: ', e);
  }
};

export { forceResendWorkout, checkForMismatchedWorkouts };
